import { Car, Shield, CreditCard, UserPlus, Star, FileText } from "lucide-react";

export default function ProfileStats({ consortiums, policies, payments, referrals, loyalty, documentsCount }) {
  var activeConsortiums = consortiums.filter(function(c) { return c.status === "ativo" || c.status === "contemplado"; }).length;
  var activePolicies = policies.filter(function(p) { return p.status === "ativa"; }).length;
  var pendingPayments = payments.filter(function(p) { return p.status === "pendente"; }).length;

  var items = [
    { icon: Car, label: "Consórcios Ativos", value: activeConsortiums, color: "text-[#F26A4B]", bg: "bg-[#F26A4B]/10" },
    { icon: Shield, label: "Apolices Ativas", value: activePolicies, color: "text-[#3B82F6]", bg: "bg-[#3B82F6]/10" },
    { icon: CreditCard, label: "Pgtos Pendentes", value: pendingPayments, color: "text-amber-500", bg: "bg-amber-500/10" },
    { icon: FileText, label: "Documentos", value: documentsCount || 0, color: "text-teal-500", bg: "bg-teal-500/10" },
    { icon: UserPlus, label: "Indicacoes", value: referrals.length, color: "text-purple-500", bg: "bg-purple-500/10" },
  ];

  if (loyalty && loyalty.enabled) {
    items.push({ icon: Star, label: "Pontos", value: loyalty.points, color: "text-emerald-500", bg: "bg-emerald-500/10" });
  }

  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3" data-testid="profile-stats">
      {items.map(function(item, idx) {
        var Icon = item.icon;
        return (
          <div key={idx} className="bg-white rounded-xl shadow-sm border border-gray-100 p-3 sm:p-4">
            <div className="flex items-center gap-2 mb-2">
              <div className={"p-1.5 rounded-lg " + item.bg}><Icon className={"w-4 h-4 " + item.color} /></div>
              <span className="text-xs text-gray-500">{item.label}</span>
            </div>
            <p className="text-xl font-bold text-[#0A2F3D]" data-testid={"stat-" + item.label.toLowerCase().replace(/ /g, "-")}>{item.value}</p>
          </div>
        );
      })}
    </div>
  );
}
